export default "__VITE_ASSET__BClLUUUJ__"